import { apiClient, WEBSITE_TAGS } from '../api';

export const fetchTags = async (taggableType) => {
  const params = {
    taggable_type: taggableType,
  };

  const response = await apiClient.get(WEBSITE_TAGS(), { params });

  return response.data;
};
